import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
import ProjectDetailContent from '../ProjectDetailContent';
import styles from './styles.module.scss';
const OverviewTab = ({
  changeProjectStatus,
  changeStatusToActivated,
  confirm,
  sendMessengerTo,
  createSubProject,
  subprojects
}) => {
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    projectDetail,
    tagCategoryList
  } = adminProjectDetailStore;
  return <div className={styles.container}>
      <ProjectDetailContent changeProjectStatus={changeProjectStatus} changeStatusToActivated={changeStatusToActivated} confirm={confirm} projectDetail={projectDetail} sendMessengerTo={sendMessengerTo} createSubProject={createSubProject} subprojects={subprojects} tagCategoryList={tagCategoryList} />
    </div>;
};
export default observer(OverviewTab);